import type { PaymentSchema } from '$api-clients/generated';

export enum PlatformFeeAlertStatus {
  MISSING_PAYMENT_METHOD = 'MISSING_PAYMENT_METHOD',
  INVALID_PAYMENT_METHOD = 'INVALID_PAYMENT_METHOD',
  PAST_DUE_BALANCE = 'PAST_DUE_BALANCE',
  MISSING_PAYMENT_METHOD_AND_HAS_PAST_DUE_BALANCE = 'MISSING_PAYMENT_METHOD_AND_HAS_PAST_DUE_BALANCE',
  MULTIPLE_PAST_DUE_INVOICES = 'MULTIPLE_PAST_DUE_INVOICES',
  PLATFORM_FEE_ENFORCEMENT = 'PLATFORM_FEE_ENFORCEMENT',
}

export type PlatformFee =
  | PaymentSchema.paths['/me/platform-fee']['get']['responses']['200']['content']['application/json']
  | null
  | undefined;
